/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface AgentVoiceService {
  /** @summary Get Default */
  getDefaultVoiceAgent: {
    /** @summary Get Default */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<GetDefaultVoiceAgentParameters, TMeta, TSignal> | void),
      client?: (
        schema: GetDefaultVoiceAgentSchema,
        options: {
          parameters: GetDefaultVoiceAgentParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetDefaultVoiceAgentData, GetDefaultVoiceAgentError>>
    ): Promise<RequestFnResponse<GetDefaultVoiceAgentData, GetDefaultVoiceAgentError>>;
    /** @summary Get Default */
    getQueryKey(
      parameters: DeepReadonly<GetDefaultVoiceAgentParameters> | void
    ): ServiceOperationQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Default
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.agentVoiceService.getDefaultVoiceAgent.useQuery()
     * ```
     */
    useQuery<TData = GetDefaultVoiceAgentData>(
      parameters:
        | ServiceOperationQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>
        | (DeepReadonly<GetDefaultVoiceAgentParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          GetDefaultVoiceAgentData,
          GetDefaultVoiceAgentError,
          TData,
          ServiceOperationQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetDefaultVoiceAgentError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Default
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.agentVoiceService.getDefaultVoiceAgent.useQuery()
     * ```
     */
    useQuery<TData = GetDefaultVoiceAgentData>(
      parameters:
        | ServiceOperationQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>
        | (DeepReadonly<GetDefaultVoiceAgentParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          GetDefaultVoiceAgentData,
          GetDefaultVoiceAgentError,
          TData,
          ServiceOperationQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetDefaultVoiceAgentError>>;
    /** @summary Get Default */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetDefaultVoiceAgentParameters> | void
    ): ServiceOperationInfiniteQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Default
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentVoiceService.getDefaultVoiceAgent.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetDefaultVoiceAgentParameters,
      TQueryFnData = GetDefaultVoiceAgentData,
      TData = OperationInfiniteData<TQueryFnData, GetDefaultVoiceAgentParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>
        | (DeepReadonly<GetDefaultVoiceAgentParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetDefaultVoiceAgentError,
          TData,
          ServiceOperationInfiniteQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetDefaultVoiceAgentError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Default
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentVoiceService.getDefaultVoiceAgent.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetDefaultVoiceAgentParameters,
      TQueryFnData = GetDefaultVoiceAgentData,
      TData = OperationInfiniteData<TQueryFnData, GetDefaultVoiceAgentParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>
        | (DeepReadonly<GetDefaultVoiceAgentParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetDefaultVoiceAgentError,
          TData,
          ServiceOperationInfiniteQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetDefaultVoiceAgentData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetDefaultVoiceAgentError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Default
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getDefaultVoiceAgentTotal = qraft.agentVoiceService.getDefaultVoiceAgent.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetDefaultVoiceAgentSchema,
            GetDefaultVoiceAgentData,
            TInfinite,
            GetDefaultVoiceAgentParameters,
            GetDefaultVoiceAgentError
          >
        | QueryFiltersByQueryKey<
            GetDefaultVoiceAgentSchema,
            GetDefaultVoiceAgentData,
            TInfinite,
            GetDefaultVoiceAgentParameters,
            GetDefaultVoiceAgentError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Default
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getDefaultVoiceAgentResults = qraft.agentVoiceService.getDefaultVoiceAgent.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getDefaultVoiceAgentResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getDefaultVoiceAgentCombinedResults = qraft.agentVoiceService.getDefaultVoiceAgent.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getDefaultVoiceAgentCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetDefaultVoiceAgentSchema,
          GetDefaultVoiceAgentParameters,
          GetDefaultVoiceAgentData,
          GetDefaultVoiceAgentError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetDefaultVoiceAgentData, GetDefaultVoiceAgentError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<GetDefaultVoiceAgentData, GetDefaultVoiceAgentError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Default
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.agentVoiceService.getDefaultVoiceAgent.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = GetDefaultVoiceAgentData>(
      parameters:
        | ServiceOperationQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>
        | (DeepReadonly<GetDefaultVoiceAgentParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          GetDefaultVoiceAgentData,
          GetDefaultVoiceAgentError,
          TData,
          ServiceOperationQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetDefaultVoiceAgentError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Default
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentVoiceService.getDefaultVoiceAgent.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends GetDefaultVoiceAgentParameters, TData = GetDefaultVoiceAgentData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>
        | (DeepReadonly<GetDefaultVoiceAgentParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetDefaultVoiceAgentData,
          GetDefaultVoiceAgentError,
          OperationInfiniteData<TData, GetDefaultVoiceAgentParameters>,
          ServiceOperationInfiniteQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetDefaultVoiceAgentData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetDefaultVoiceAgentParameters>,
      OperationError<GetDefaultVoiceAgentError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Default
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getDefaultVoiceAgentData = qraft.agentVoiceService.getDefaultVoiceAgent.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getDefaultVoiceAgentResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getDefaultVoiceAgentCombinedData = qraft.agentVoiceService.getDefaultVoiceAgent.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getDefaultVoiceAgentCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetDefaultVoiceAgentSchema,
          GetDefaultVoiceAgentParameters,
          GetDefaultVoiceAgentData,
          GetDefaultVoiceAgentError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<GetDefaultVoiceAgentData, GetDefaultVoiceAgentError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<UseSuspenseQueryResult<GetDefaultVoiceAgentData, GetDefaultVoiceAgentError>, 'data'>
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Get Default */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetDefaultVoiceAgentSchema,
        GetDefaultVoiceAgentData,
        GetDefaultVoiceAgentParameters,
        GetDefaultVoiceAgentError
      > | void
    ): Promise<GetDefaultVoiceAgentData>;
    /** @summary Get Default */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetDefaultVoiceAgentSchema,
        GetDefaultVoiceAgentData,
        GetDefaultVoiceAgentParameters,
        GetDefaultVoiceAgentError
      > | void
    ): Promise<void>;
    /** @summary Get Default */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetDefaultVoiceAgentSchema,
        GetDefaultVoiceAgentData,
        GetDefaultVoiceAgentParameters,
        GetDefaultVoiceAgentError
      > | void
    ): Promise<GetDefaultVoiceAgentData>;
    /** @summary Get Default */
    fetchInfiniteQuery<TPageParam extends GetDefaultVoiceAgentParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetDefaultVoiceAgentSchema,
        GetDefaultVoiceAgentData,
        GetDefaultVoiceAgentParameters,
        DeepReadonly<TPageParam>,
        GetDefaultVoiceAgentError
      > | void
    ): Promise<OperationInfiniteData<GetDefaultVoiceAgentData, GetDefaultVoiceAgentParameters>>;
    /** @summary Get Default */
    prefetchInfiniteQuery<TPageParam extends GetDefaultVoiceAgentParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetDefaultVoiceAgentSchema,
        GetDefaultVoiceAgentData,
        GetDefaultVoiceAgentParameters,
        DeepReadonly<TPageParam>,
        GetDefaultVoiceAgentError
      > | void
    ): Promise<void>;
    /** @summary Get Default */
    ensureInfiniteQueryData<TPageParam extends GetDefaultVoiceAgentParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetDefaultVoiceAgentSchema,
        GetDefaultVoiceAgentData,
        GetDefaultVoiceAgentParameters,
        DeepReadonly<TPageParam>,
        GetDefaultVoiceAgentError
      > | void
    ): Promise<OperationInfiniteData<GetDefaultVoiceAgentData, GetDefaultVoiceAgentParameters>>;
    /** @summary Get Default */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>
        | (DeepReadonly<GetDefaultVoiceAgentParameters> | void)
    ): GetDefaultVoiceAgentData | undefined;
    /** @summary Get Default */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>
        | (DeepReadonly<GetDefaultVoiceAgentParameters> | void)
    ): OperationInfiniteData<GetDefaultVoiceAgentData, GetDefaultVoiceAgentParameters> | undefined;
    /** @summary Get Default */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetDefaultVoiceAgentSchema,
            GetDefaultVoiceAgentData,
            TInfinite,
            GetDefaultVoiceAgentParameters,
            GetDefaultVoiceAgentError
          >
        | QueryFiltersByQueryKey<
            GetDefaultVoiceAgentSchema,
            GetDefaultVoiceAgentData,
            TInfinite,
            GetDefaultVoiceAgentParameters,
            GetDefaultVoiceAgentError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>,
            data: NoInfer<OperationInfiniteData<GetDefaultVoiceAgentData, GetDefaultVoiceAgentParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>,
            data: GetDefaultVoiceAgentData | undefined,
          ]
        >;
    /** @summary Get Default */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>
        | (DeepReadonly<GetDefaultVoiceAgentParameters> | void)
    ): QueryState<GetDefaultVoiceAgentData, GetDefaultVoiceAgentError> | undefined;
    /** @summary Get Default */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetDefaultVoiceAgentParameters>
        | ServiceOperationInfiniteQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>
        | void
    ):
      | QueryState<
          OperationInfiniteData<GetDefaultVoiceAgentData, GetDefaultVoiceAgentParameters>,
          GetDefaultVoiceAgentError
        >
      | undefined;
    /** @summary Get Default */
    setQueryData(
      parameters:
        | (DeepReadonly<GetDefaultVoiceAgentParameters> | undefined)
        | ServiceOperationQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>,
      updater: Updater<
        NoInfer<GetDefaultVoiceAgentData> | undefined,
        NoInfer<DeepReadonly<GetDefaultVoiceAgentData>> | undefined
      >,
      options?: SetDataOptions
    ): GetDefaultVoiceAgentData | undefined;
    /** @summary Get Default */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<GetDefaultVoiceAgentParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<GetDefaultVoiceAgentSchema, GetDefaultVoiceAgentParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<GetDefaultVoiceAgentData, GetDefaultVoiceAgentParameters>> | undefined,
        | NoInfer<DeepReadonly<OperationInfiniteData<GetDefaultVoiceAgentData, GetDefaultVoiceAgentParameters>>>
        | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetDefaultVoiceAgentData, GetDefaultVoiceAgentParameters> | undefined;
    /** @summary Get Default */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetDefaultVoiceAgentSchema,
            GetDefaultVoiceAgentData,
            TInfinite,
            GetDefaultVoiceAgentParameters,
            GetDefaultVoiceAgentError
          >
        | QueryFiltersByQueryKey<
            GetDefaultVoiceAgentSchema,
            GetDefaultVoiceAgentData,
            TInfinite,
            GetDefaultVoiceAgentParameters,
            GetDefaultVoiceAgentError
          >,
      updater: Updater<NoInfer<GetDefaultVoiceAgentData> | undefined, NoInfer<GetDefaultVoiceAgentData> | undefined>,
      options?: SetDataOptions
    ): Array<GetDefaultVoiceAgentData | undefined>;
    /** @summary Get Default */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetDefaultVoiceAgentSchema,
        GetDefaultVoiceAgentData,
        TInfinite,
        GetDefaultVoiceAgentParameters,
        GetDefaultVoiceAgentError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Get Default */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetDefaultVoiceAgentSchema,
            GetDefaultVoiceAgentData,
            TInfinite,
            GetDefaultVoiceAgentParameters,
            GetDefaultVoiceAgentError
          >
        | QueryFiltersByQueryKey<
            GetDefaultVoiceAgentSchema,
            GetDefaultVoiceAgentData,
            TInfinite,
            GetDefaultVoiceAgentParameters,
            GetDefaultVoiceAgentError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Get Default */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetDefaultVoiceAgentSchema,
            GetDefaultVoiceAgentData,
            TInfinite,
            GetDefaultVoiceAgentParameters,
            GetDefaultVoiceAgentError
          >
        | QueryFiltersByQueryKey<
            GetDefaultVoiceAgentSchema,
            GetDefaultVoiceAgentData,
            TInfinite,
            GetDefaultVoiceAgentParameters,
            GetDefaultVoiceAgentError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Get Default */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetDefaultVoiceAgentSchema,
            GetDefaultVoiceAgentData,
            TInfinite,
            GetDefaultVoiceAgentParameters,
            GetDefaultVoiceAgentError
          >
        | QueryFiltersByQueryKey<
            GetDefaultVoiceAgentSchema,
            GetDefaultVoiceAgentData,
            TInfinite,
            GetDefaultVoiceAgentParameters,
            GetDefaultVoiceAgentError
          >
    ): void;
    /** @summary Get Default */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetDefaultVoiceAgentSchema,
            GetDefaultVoiceAgentData,
            TInfinite,
            GetDefaultVoiceAgentParameters,
            GetDefaultVoiceAgentError
          >
        | QueryFiltersByQueryKey<
            GetDefaultVoiceAgentSchema,
            GetDefaultVoiceAgentData,
            TInfinite,
            GetDefaultVoiceAgentParameters,
            GetDefaultVoiceAgentError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Get Default */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetDefaultVoiceAgentSchema,
            GetDefaultVoiceAgentData,
            TInfinite,
            GetDefaultVoiceAgentParameters,
            GetDefaultVoiceAgentError
          >
        | QueryFiltersByQueryKey<
            GetDefaultVoiceAgentSchema,
            GetDefaultVoiceAgentData,
            TInfinite,
            GetDefaultVoiceAgentParameters,
            GetDefaultVoiceAgentError
          >
    ): number;
    schema: GetDefaultVoiceAgentSchema;
    types: {
      parameters: GetDefaultVoiceAgentParameters;
      data: GetDefaultVoiceAgentData;
      error: GetDefaultVoiceAgentError;
    };
  };
  /** @summary Create Default */
  createDefaultVoiceAgent: {
    /** @summary Create Default */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        CreateDefaultVoiceAgentBody,
        CreateDefaultVoiceAgentParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: CreateDefaultVoiceAgentSchema,
        options: ServiceOperationMutationFnOptions<
          CreateDefaultVoiceAgentBody,
          CreateDefaultVoiceAgentParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<CreateDefaultVoiceAgentData, CreateDefaultVoiceAgentError>>
    ): Promise<RequestFnResponse<CreateDefaultVoiceAgentData, CreateDefaultVoiceAgentError>>;
    /** @summary Create Default */
    getMutationKey(
      parameters: DeepReadonly<CreateDefaultVoiceAgentParameters> | void
    ): ServiceOperationMutationKey<CreateDefaultVoiceAgentSchema, CreateDefaultVoiceAgentParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create Default
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentVoiceService.createDefaultVoiceAgent.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentVoiceService.createDefaultVoiceAgent.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateDefaultVoiceAgentBody, TContext = unknown>(
      parameters: DeepReadonly<CreateDefaultVoiceAgentParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateDefaultVoiceAgentSchema,
        CreateDefaultVoiceAgentData,
        CreateDefaultVoiceAgentParameters,
        TVariables,
        OperationError<CreateDefaultVoiceAgentError>,
        TContext
      >
    ): UseMutationResult<
      CreateDefaultVoiceAgentData,
      OperationError<CreateDefaultVoiceAgentError>,
      TVariables | void,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create Default
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentVoiceService.createDefaultVoiceAgent.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentVoiceService.createDefaultVoiceAgent.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<CreateDefaultVoiceAgentBody, CreateDefaultVoiceAgentParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateDefaultVoiceAgentSchema,
        CreateDefaultVoiceAgentData,
        CreateDefaultVoiceAgentParameters,
        TVariables,
        OperationError<CreateDefaultVoiceAgentError>,
        TContext
      >
    ): UseMutationResult<
      CreateDefaultVoiceAgentData,
      OperationError<CreateDefaultVoiceAgentError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create Default
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createDefaultVoiceAgentTotal = qraft.agentVoiceService.createDefaultVoiceAgent.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createDefaultVoiceAgentTotal = qraft.agentVoiceService.createDefaultVoiceAgent.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateDefaultVoiceAgentBody,
            CreateDefaultVoiceAgentData,
            CreateDefaultVoiceAgentParameters,
            OperationError<CreateDefaultVoiceAgentError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateDefaultVoiceAgentSchema,
            CreateDefaultVoiceAgentBody,
            CreateDefaultVoiceAgentData,
            CreateDefaultVoiceAgentParameters,
            OperationError<CreateDefaultVoiceAgentError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create Default
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createDefaultVoiceAgentPendingMutationVariables = qraft.agentVoiceService.createDefaultVoiceAgent.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createDefaultVoiceAgentMutationData = qraft.agentVoiceService.createDefaultVoiceAgent.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateDefaultVoiceAgentData,
        OperationError<CreateDefaultVoiceAgentError>,
        MutationVariables<CreateDefaultVoiceAgentBody, CreateDefaultVoiceAgentParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateDefaultVoiceAgentBody,
            CreateDefaultVoiceAgentData,
            CreateDefaultVoiceAgentParameters,
            OperationError<CreateDefaultVoiceAgentError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateDefaultVoiceAgentSchema,
            CreateDefaultVoiceAgentBody,
            CreateDefaultVoiceAgentData,
            CreateDefaultVoiceAgentParameters,
            OperationError<CreateDefaultVoiceAgentError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateDefaultVoiceAgentData,
          OperationError<CreateDefaultVoiceAgentError>,
          MutationVariables<CreateDefaultVoiceAgentBody, CreateDefaultVoiceAgentParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Create Default */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateDefaultVoiceAgentBody,
            CreateDefaultVoiceAgentData,
            CreateDefaultVoiceAgentParameters,
            OperationError<CreateDefaultVoiceAgentError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateDefaultVoiceAgentSchema,
            CreateDefaultVoiceAgentBody,
            CreateDefaultVoiceAgentData,
            CreateDefaultVoiceAgentParameters,
            OperationError<CreateDefaultVoiceAgentError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create Default
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentVoiceService.createDefaultVoiceAgent.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentVoiceService.createDefaultVoiceAgent.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateDefaultVoiceAgentBody,
              CreateDefaultVoiceAgentData,
              CreateDefaultVoiceAgentParameters,
              OperationError<CreateDefaultVoiceAgentError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateDefaultVoiceAgentSchema,
              CreateDefaultVoiceAgentBody,
              CreateDefaultVoiceAgentData,
              CreateDefaultVoiceAgentParameters,
              OperationError<CreateDefaultVoiceAgentError>,
              TContext
            >
      ):
        | Mutation<
            CreateDefaultVoiceAgentData,
            CreateDefaultVoiceAgentError,
            MutationVariables<CreateDefaultVoiceAgentBody, CreateDefaultVoiceAgentParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateDefaultVoiceAgentBody,
              CreateDefaultVoiceAgentData,
              CreateDefaultVoiceAgentParameters,
              OperationError<CreateDefaultVoiceAgentError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateDefaultVoiceAgentSchema,
              CreateDefaultVoiceAgentBody,
              CreateDefaultVoiceAgentData,
              CreateDefaultVoiceAgentParameters,
              OperationError<CreateDefaultVoiceAgentError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateDefaultVoiceAgentData,
          CreateDefaultVoiceAgentError,
          MutationVariables<CreateDefaultVoiceAgentBody, CreateDefaultVoiceAgentParameters>,
          TContext
        >
      >;
    };
    schema: CreateDefaultVoiceAgentSchema;
    types: {
      parameters: CreateDefaultVoiceAgentParameters;
      data: CreateDefaultVoiceAgentData;
      error: CreateDefaultVoiceAgentError;
      body: CreateDefaultVoiceAgentBody;
    };
  };
  /** @summary List Voice Agents */
  listVoiceAgents: {
    /** @summary List Voice Agents */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<ListVoiceAgentsParameters, TMeta, TSignal> | void),
      client?: (
        schema: ListVoiceAgentsSchema,
        options: {
          parameters: ListVoiceAgentsParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<ListVoiceAgentsData, ListVoiceAgentsError>>
    ): Promise<RequestFnResponse<ListVoiceAgentsData, ListVoiceAgentsError>>;
    /** @summary List Voice Agents */
    getQueryKey(
      parameters: DeepReadonly<ListVoiceAgentsParameters> | void
    ): ServiceOperationQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List Voice Agents
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.agentVoiceService.listVoiceAgents.useQuery()
     * ```
     */
    useQuery<TData = ListVoiceAgentsData>(
      parameters:
        | ServiceOperationQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>
        | (DeepReadonly<ListVoiceAgentsParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          ListVoiceAgentsData,
          ListVoiceAgentsError,
          TData,
          ServiceOperationQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<ListVoiceAgentsError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List Voice Agents
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.agentVoiceService.listVoiceAgents.useQuery()
     * ```
     */
    useQuery<TData = ListVoiceAgentsData>(
      parameters:
        | ServiceOperationQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>
        | (DeepReadonly<ListVoiceAgentsParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          ListVoiceAgentsData,
          ListVoiceAgentsError,
          TData,
          ServiceOperationQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<ListVoiceAgentsError>>;
    /** @summary List Voice Agents */
    getInfiniteQueryKey(
      parameters: DeepReadonly<ListVoiceAgentsParameters> | void
    ): ServiceOperationInfiniteQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List Voice Agents
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentVoiceService.listVoiceAgents.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListVoiceAgentsParameters,
      TQueryFnData = ListVoiceAgentsData,
      TData = OperationInfiniteData<TQueryFnData, ListVoiceAgentsParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>
        | (DeepReadonly<ListVoiceAgentsParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListVoiceAgentsError,
          TData,
          ServiceOperationInfiniteQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<ListVoiceAgentsError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List Voice Agents
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentVoiceService.listVoiceAgents.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListVoiceAgentsParameters,
      TQueryFnData = ListVoiceAgentsData,
      TData = OperationInfiniteData<TQueryFnData, ListVoiceAgentsParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>
        | (DeepReadonly<ListVoiceAgentsParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListVoiceAgentsError,
          TData,
          ServiceOperationInfiniteQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ListVoiceAgentsData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<ListVoiceAgentsError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary List Voice Agents
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const listVoiceAgentsTotal = qraft.agentVoiceService.listVoiceAgents.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListVoiceAgentsSchema,
            ListVoiceAgentsData,
            TInfinite,
            ListVoiceAgentsParameters,
            ListVoiceAgentsError
          >
        | QueryFiltersByQueryKey<
            ListVoiceAgentsSchema,
            ListVoiceAgentsData,
            TInfinite,
            ListVoiceAgentsParameters,
            ListVoiceAgentsError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary List Voice Agents
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const listVoiceAgentsResults = qraft.agentVoiceService.listVoiceAgents.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listVoiceAgentsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const listVoiceAgentsCombinedResults = qraft.agentVoiceService.listVoiceAgents.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listVoiceAgentsCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          ListVoiceAgentsSchema,
          ListVoiceAgentsParameters,
          ListVoiceAgentsData,
          ListVoiceAgentsError
        >
      >,
      TCombinedResult = Array<UseQueryResult<ListVoiceAgentsData, ListVoiceAgentsError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<ListVoiceAgentsData, ListVoiceAgentsError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary List Voice Agents
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.agentVoiceService.listVoiceAgents.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = ListVoiceAgentsData>(
      parameters:
        | ServiceOperationQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>
        | (DeepReadonly<ListVoiceAgentsParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          ListVoiceAgentsData,
          ListVoiceAgentsError,
          TData,
          ServiceOperationQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<ListVoiceAgentsError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary List Voice Agents
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentVoiceService.listVoiceAgents.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends ListVoiceAgentsParameters, TData = ListVoiceAgentsData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>
        | (DeepReadonly<ListVoiceAgentsParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          ListVoiceAgentsData,
          ListVoiceAgentsError,
          OperationInfiniteData<TData, ListVoiceAgentsParameters>,
          ServiceOperationInfiniteQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ListVoiceAgentsData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, ListVoiceAgentsParameters>,
      OperationError<ListVoiceAgentsError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary List Voice Agents
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const listVoiceAgentsData = qraft.agentVoiceService.listVoiceAgents.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listVoiceAgentsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const listVoiceAgentsCombinedData = qraft.agentVoiceService.listVoiceAgents.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listVoiceAgentsCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          ListVoiceAgentsSchema,
          ListVoiceAgentsParameters,
          ListVoiceAgentsData,
          ListVoiceAgentsError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<ListVoiceAgentsData, ListVoiceAgentsError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<ListVoiceAgentsData, ListVoiceAgentsError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary List Voice Agents */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListVoiceAgentsSchema,
        ListVoiceAgentsData,
        ListVoiceAgentsParameters,
        ListVoiceAgentsError
      > | void
    ): Promise<ListVoiceAgentsData>;
    /** @summary List Voice Agents */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListVoiceAgentsSchema,
        ListVoiceAgentsData,
        ListVoiceAgentsParameters,
        ListVoiceAgentsError
      > | void
    ): Promise<void>;
    /** @summary List Voice Agents */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        ListVoiceAgentsSchema,
        ListVoiceAgentsData,
        ListVoiceAgentsParameters,
        ListVoiceAgentsError
      > | void
    ): Promise<ListVoiceAgentsData>;
    /** @summary List Voice Agents */
    fetchInfiniteQuery<TPageParam extends ListVoiceAgentsParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListVoiceAgentsSchema,
        ListVoiceAgentsData,
        ListVoiceAgentsParameters,
        DeepReadonly<TPageParam>,
        ListVoiceAgentsError
      > | void
    ): Promise<OperationInfiniteData<ListVoiceAgentsData, ListVoiceAgentsParameters>>;
    /** @summary List Voice Agents */
    prefetchInfiniteQuery<TPageParam extends ListVoiceAgentsParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListVoiceAgentsSchema,
        ListVoiceAgentsData,
        ListVoiceAgentsParameters,
        DeepReadonly<TPageParam>,
        ListVoiceAgentsError
      > | void
    ): Promise<void>;
    /** @summary List Voice Agents */
    ensureInfiniteQueryData<TPageParam extends ListVoiceAgentsParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        ListVoiceAgentsSchema,
        ListVoiceAgentsData,
        ListVoiceAgentsParameters,
        DeepReadonly<TPageParam>,
        ListVoiceAgentsError
      > | void
    ): Promise<OperationInfiniteData<ListVoiceAgentsData, ListVoiceAgentsParameters>>;
    /** @summary List Voice Agents */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>
        | (DeepReadonly<ListVoiceAgentsParameters> | void)
    ): ListVoiceAgentsData | undefined;
    /** @summary List Voice Agents */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>
        | (DeepReadonly<ListVoiceAgentsParameters> | void)
    ): OperationInfiniteData<ListVoiceAgentsData, ListVoiceAgentsParameters> | undefined;
    /** @summary List Voice Agents */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListVoiceAgentsSchema,
            ListVoiceAgentsData,
            TInfinite,
            ListVoiceAgentsParameters,
            ListVoiceAgentsError
          >
        | QueryFiltersByQueryKey<
            ListVoiceAgentsSchema,
            ListVoiceAgentsData,
            TInfinite,
            ListVoiceAgentsParameters,
            ListVoiceAgentsError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>,
            data: NoInfer<OperationInfiniteData<ListVoiceAgentsData, ListVoiceAgentsParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>,
            data: ListVoiceAgentsData | undefined,
          ]
        >;
    /** @summary List Voice Agents */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>
        | (DeepReadonly<ListVoiceAgentsParameters> | void)
    ): QueryState<ListVoiceAgentsData, ListVoiceAgentsError> | undefined;
    /** @summary List Voice Agents */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<ListVoiceAgentsParameters>
        | ServiceOperationInfiniteQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>
        | void
    ):
      | QueryState<OperationInfiniteData<ListVoiceAgentsData, ListVoiceAgentsParameters>, ListVoiceAgentsError>
      | undefined;
    /** @summary List Voice Agents */
    setQueryData(
      parameters:
        | (DeepReadonly<ListVoiceAgentsParameters> | undefined)
        | ServiceOperationQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>,
      updater: Updater<
        NoInfer<ListVoiceAgentsData> | undefined,
        NoInfer<DeepReadonly<ListVoiceAgentsData>> | undefined
      >,
      options?: SetDataOptions
    ): ListVoiceAgentsData | undefined;
    /** @summary List Voice Agents */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<ListVoiceAgentsParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<ListVoiceAgentsSchema, ListVoiceAgentsParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<ListVoiceAgentsData, ListVoiceAgentsParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<ListVoiceAgentsData, ListVoiceAgentsParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<ListVoiceAgentsData, ListVoiceAgentsParameters> | undefined;
    /** @summary List Voice Agents */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            ListVoiceAgentsSchema,
            ListVoiceAgentsData,
            TInfinite,
            ListVoiceAgentsParameters,
            ListVoiceAgentsError
          >
        | QueryFiltersByQueryKey<
            ListVoiceAgentsSchema,
            ListVoiceAgentsData,
            TInfinite,
            ListVoiceAgentsParameters,
            ListVoiceAgentsError
          >,
      updater: Updater<NoInfer<ListVoiceAgentsData> | undefined, NoInfer<ListVoiceAgentsData> | undefined>,
      options?: SetDataOptions
    ): Array<ListVoiceAgentsData | undefined>;
    /** @summary List Voice Agents */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        ListVoiceAgentsSchema,
        ListVoiceAgentsData,
        TInfinite,
        ListVoiceAgentsParameters,
        ListVoiceAgentsError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary List Voice Agents */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListVoiceAgentsSchema,
            ListVoiceAgentsData,
            TInfinite,
            ListVoiceAgentsParameters,
            ListVoiceAgentsError
          >
        | QueryFiltersByQueryKey<
            ListVoiceAgentsSchema,
            ListVoiceAgentsData,
            TInfinite,
            ListVoiceAgentsParameters,
            ListVoiceAgentsError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary List Voice Agents */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListVoiceAgentsSchema,
            ListVoiceAgentsData,
            TInfinite,
            ListVoiceAgentsParameters,
            ListVoiceAgentsError
          >
        | QueryFiltersByQueryKey<
            ListVoiceAgentsSchema,
            ListVoiceAgentsData,
            TInfinite,
            ListVoiceAgentsParameters,
            ListVoiceAgentsError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary List Voice Agents */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListVoiceAgentsSchema,
            ListVoiceAgentsData,
            TInfinite,
            ListVoiceAgentsParameters,
            ListVoiceAgentsError
          >
        | QueryFiltersByQueryKey<
            ListVoiceAgentsSchema,
            ListVoiceAgentsData,
            TInfinite,
            ListVoiceAgentsParameters,
            ListVoiceAgentsError
          >
    ): void;
    /** @summary List Voice Agents */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListVoiceAgentsSchema,
            ListVoiceAgentsData,
            TInfinite,
            ListVoiceAgentsParameters,
            ListVoiceAgentsError
          >
        | QueryFiltersByQueryKey<
            ListVoiceAgentsSchema,
            ListVoiceAgentsData,
            TInfinite,
            ListVoiceAgentsParameters,
            ListVoiceAgentsError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary List Voice Agents */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListVoiceAgentsSchema,
            ListVoiceAgentsData,
            TInfinite,
            ListVoiceAgentsParameters,
            ListVoiceAgentsError
          >
        | QueryFiltersByQueryKey<
            ListVoiceAgentsSchema,
            ListVoiceAgentsData,
            TInfinite,
            ListVoiceAgentsParameters,
            ListVoiceAgentsError
          >
    ): number;
    schema: ListVoiceAgentsSchema;
    types: {
      parameters: ListVoiceAgentsParameters;
      data: ListVoiceAgentsData;
      error: ListVoiceAgentsError;
    };
  };
  /** @summary Create */
  createVoiceAgent: {
    /** @summary Create */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<CreateVoiceAgentBody, CreateVoiceAgentParameters, TMeta, TSignal>,
      client?: (
        schema: CreateVoiceAgentSchema,
        options: ServiceOperationMutationFnOptions<CreateVoiceAgentBody, CreateVoiceAgentParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<CreateVoiceAgentData, CreateVoiceAgentError>>
    ): Promise<RequestFnResponse<CreateVoiceAgentData, CreateVoiceAgentError>>;
    /** @summary Create */
    getMutationKey(
      parameters: DeepReadonly<CreateVoiceAgentParameters> | void
    ): ServiceOperationMutationKey<CreateVoiceAgentSchema, CreateVoiceAgentParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentVoiceService.createVoiceAgent.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentVoiceService.createVoiceAgent.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateVoiceAgentBody, TContext = unknown>(
      parameters: DeepReadonly<CreateVoiceAgentParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateVoiceAgentSchema,
        CreateVoiceAgentData,
        CreateVoiceAgentParameters,
        TVariables,
        OperationError<CreateVoiceAgentError>,
        TContext
      >
    ): UseMutationResult<CreateVoiceAgentData, OperationError<CreateVoiceAgentError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentVoiceService.createVoiceAgent.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentVoiceService.createVoiceAgent.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<CreateVoiceAgentBody, CreateVoiceAgentParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateVoiceAgentSchema,
        CreateVoiceAgentData,
        CreateVoiceAgentParameters,
        TVariables,
        OperationError<CreateVoiceAgentError>,
        TContext
      >
    ): UseMutationResult<CreateVoiceAgentData, OperationError<CreateVoiceAgentError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createVoiceAgentTotal = qraft.agentVoiceService.createVoiceAgent.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createVoiceAgentTotal = qraft.agentVoiceService.createVoiceAgent.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateVoiceAgentBody,
            CreateVoiceAgentData,
            CreateVoiceAgentParameters,
            OperationError<CreateVoiceAgentError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateVoiceAgentSchema,
            CreateVoiceAgentBody,
            CreateVoiceAgentData,
            CreateVoiceAgentParameters,
            OperationError<CreateVoiceAgentError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createVoiceAgentPendingMutationVariables = qraft.agentVoiceService.createVoiceAgent.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createVoiceAgentMutationData = qraft.agentVoiceService.createVoiceAgent.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateVoiceAgentData,
        OperationError<CreateVoiceAgentError>,
        MutationVariables<CreateVoiceAgentBody, CreateVoiceAgentParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateVoiceAgentBody,
            CreateVoiceAgentData,
            CreateVoiceAgentParameters,
            OperationError<CreateVoiceAgentError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateVoiceAgentSchema,
            CreateVoiceAgentBody,
            CreateVoiceAgentData,
            CreateVoiceAgentParameters,
            OperationError<CreateVoiceAgentError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateVoiceAgentData,
          OperationError<CreateVoiceAgentError>,
          MutationVariables<CreateVoiceAgentBody, CreateVoiceAgentParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Create */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateVoiceAgentBody,
            CreateVoiceAgentData,
            CreateVoiceAgentParameters,
            OperationError<CreateVoiceAgentError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateVoiceAgentSchema,
            CreateVoiceAgentBody,
            CreateVoiceAgentData,
            CreateVoiceAgentParameters,
            OperationError<CreateVoiceAgentError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentVoiceService.createVoiceAgent.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentVoiceService.createVoiceAgent.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateVoiceAgentBody,
              CreateVoiceAgentData,
              CreateVoiceAgentParameters,
              OperationError<CreateVoiceAgentError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateVoiceAgentSchema,
              CreateVoiceAgentBody,
              CreateVoiceAgentData,
              CreateVoiceAgentParameters,
              OperationError<CreateVoiceAgentError>,
              TContext
            >
      ):
        | Mutation<
            CreateVoiceAgentData,
            CreateVoiceAgentError,
            MutationVariables<CreateVoiceAgentBody, CreateVoiceAgentParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateVoiceAgentBody,
              CreateVoiceAgentData,
              CreateVoiceAgentParameters,
              OperationError<CreateVoiceAgentError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateVoiceAgentSchema,
              CreateVoiceAgentBody,
              CreateVoiceAgentData,
              CreateVoiceAgentParameters,
              OperationError<CreateVoiceAgentError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateVoiceAgentData,
          CreateVoiceAgentError,
          MutationVariables<CreateVoiceAgentBody, CreateVoiceAgentParameters>,
          TContext
        >
      >;
    };
    schema: CreateVoiceAgentSchema;
    types: {
      parameters: CreateVoiceAgentParameters;
      data: CreateVoiceAgentData;
      error: CreateVoiceAgentError;
      body: CreateVoiceAgentBody;
    };
  };
  /** @summary Update */
  updateVoiceAgent: {
    /** @summary Update */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<UpdateVoiceAgentBody, UpdateVoiceAgentParameters, TMeta, TSignal>,
      client?: (
        schema: UpdateVoiceAgentSchema,
        options: ServiceOperationMutationFnOptions<UpdateVoiceAgentBody, UpdateVoiceAgentParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<UpdateVoiceAgentData, UpdateVoiceAgentError>>
    ): Promise<RequestFnResponse<UpdateVoiceAgentData, UpdateVoiceAgentError>>;
    /** @summary Update */
    getMutationKey(
      parameters: DeepReadonly<UpdateVoiceAgentParameters> | void
    ): ServiceOperationMutationKey<UpdateVoiceAgentSchema, UpdateVoiceAgentParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentVoiceService.updateVoiceAgent.useMutation({
     *     path: {
     *         id: id
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentVoiceService.updateVoiceAgent.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         id: id
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends UpdateVoiceAgentBody, TContext = unknown>(
      parameters: DeepReadonly<UpdateVoiceAgentParameters>,
      options?: ServiceOperationUseMutationOptions<
        UpdateVoiceAgentSchema,
        UpdateVoiceAgentData,
        UpdateVoiceAgentParameters,
        TVariables,
        OperationError<UpdateVoiceAgentError>,
        TContext
      >
    ): UseMutationResult<UpdateVoiceAgentData, OperationError<UpdateVoiceAgentError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentVoiceService.updateVoiceAgent.useMutation({
     *     path: {
     *         id: id
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentVoiceService.updateVoiceAgent.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         id: id
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<UpdateVoiceAgentBody, UpdateVoiceAgentParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UpdateVoiceAgentSchema,
        UpdateVoiceAgentData,
        UpdateVoiceAgentParameters,
        TVariables,
        OperationError<UpdateVoiceAgentError>,
        TContext
      >
    ): UseMutationResult<UpdateVoiceAgentData, OperationError<UpdateVoiceAgentError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const updateVoiceAgentTotal = qraft.agentVoiceService.updateVoiceAgent.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const updateVoiceAgentTotal = qraft.agentVoiceService.updateVoiceAgent.useIsMutating({
     *     parameters: {
     *         path: {
     *             id: id
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UpdateVoiceAgentBody,
            UpdateVoiceAgentData,
            UpdateVoiceAgentParameters,
            OperationError<UpdateVoiceAgentError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateVoiceAgentSchema,
            UpdateVoiceAgentBody,
            UpdateVoiceAgentData,
            UpdateVoiceAgentParameters,
            OperationError<UpdateVoiceAgentError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const updateVoiceAgentPendingMutationVariables = qraft.agentVoiceService.updateVoiceAgent.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const updateVoiceAgentMutationData = qraft.agentVoiceService.updateVoiceAgent.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 id: id
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UpdateVoiceAgentData,
        OperationError<UpdateVoiceAgentError>,
        MutationVariables<UpdateVoiceAgentBody, UpdateVoiceAgentParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UpdateVoiceAgentBody,
            UpdateVoiceAgentData,
            UpdateVoiceAgentParameters,
            OperationError<UpdateVoiceAgentError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateVoiceAgentSchema,
            UpdateVoiceAgentBody,
            UpdateVoiceAgentData,
            UpdateVoiceAgentParameters,
            OperationError<UpdateVoiceAgentError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UpdateVoiceAgentData,
          OperationError<UpdateVoiceAgentError>,
          MutationVariables<UpdateVoiceAgentBody, UpdateVoiceAgentParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Update */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UpdateVoiceAgentBody,
            UpdateVoiceAgentData,
            UpdateVoiceAgentParameters,
            OperationError<UpdateVoiceAgentError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateVoiceAgentSchema,
            UpdateVoiceAgentBody,
            UpdateVoiceAgentData,
            UpdateVoiceAgentParameters,
            OperationError<UpdateVoiceAgentError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentVoiceService.updateVoiceAgent.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             id: id
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentVoiceService.updateVoiceAgent.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UpdateVoiceAgentBody,
              UpdateVoiceAgentData,
              UpdateVoiceAgentParameters,
              OperationError<UpdateVoiceAgentError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateVoiceAgentSchema,
              UpdateVoiceAgentBody,
              UpdateVoiceAgentData,
              UpdateVoiceAgentParameters,
              OperationError<UpdateVoiceAgentError>,
              TContext
            >
      ):
        | Mutation<
            UpdateVoiceAgentData,
            UpdateVoiceAgentError,
            MutationVariables<UpdateVoiceAgentBody, UpdateVoiceAgentParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UpdateVoiceAgentBody,
              UpdateVoiceAgentData,
              UpdateVoiceAgentParameters,
              OperationError<UpdateVoiceAgentError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateVoiceAgentSchema,
              UpdateVoiceAgentBody,
              UpdateVoiceAgentData,
              UpdateVoiceAgentParameters,
              OperationError<UpdateVoiceAgentError>,
              TContext
            >
      ): Array<
        Mutation<
          UpdateVoiceAgentData,
          UpdateVoiceAgentError,
          MutationVariables<UpdateVoiceAgentBody, UpdateVoiceAgentParameters>,
          TContext
        >
      >;
    };
    schema: UpdateVoiceAgentSchema;
    types: {
      parameters: UpdateVoiceAgentParameters;
      data: UpdateVoiceAgentData;
      error: UpdateVoiceAgentError;
      body: UpdateVoiceAgentBody;
    };
  };
  /** @summary Build */
  buildVoiceAgent: {
    /** @summary Build */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters, TMeta, TSignal>
        | QueryFnOptionsByParameters<BuildVoiceAgentParameters, TMeta, TSignal>,
      client?: (
        schema: BuildVoiceAgentSchema,
        options: {
          parameters: BuildVoiceAgentParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<BuildVoiceAgentData, BuildVoiceAgentError>>
    ): Promise<RequestFnResponse<BuildVoiceAgentData, BuildVoiceAgentError>>;
    /** @summary Build */
    getQueryKey(
      parameters: DeepReadonly<BuildVoiceAgentParameters>
    ): ServiceOperationQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Build
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.agentVoiceService.buildVoiceAgent.useQuery({
     *     path: {
     *         id: id
     *     }
     * })
     * ```
     */
    useQuery<TData = BuildVoiceAgentData>(
      parameters:
        | ServiceOperationQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>
        | DeepReadonly<BuildVoiceAgentParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          BuildVoiceAgentData,
          BuildVoiceAgentError,
          TData,
          ServiceOperationQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<BuildVoiceAgentError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Build
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.agentVoiceService.buildVoiceAgent.useQuery({
     *     path: {
     *         id: id
     *     }
     * })
     * ```
     */
    useQuery<TData = BuildVoiceAgentData>(
      parameters:
        | ServiceOperationQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>
        | DeepReadonly<BuildVoiceAgentParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          BuildVoiceAgentData,
          BuildVoiceAgentError,
          TData,
          ServiceOperationQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<BuildVoiceAgentError>>;
    /** @summary Build */
    getInfiniteQueryKey(
      parameters: DeepReadonly<BuildVoiceAgentParameters>
    ): ServiceOperationInfiniteQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Build
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentVoiceService.buildVoiceAgent.useInfiniteQuery({
     *     path: {
     *         id: id
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends BuildVoiceAgentParameters,
      TQueryFnData = BuildVoiceAgentData,
      TData = OperationInfiniteData<TQueryFnData, BuildVoiceAgentParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>
        | DeepReadonly<BuildVoiceAgentParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          BuildVoiceAgentError,
          TData,
          ServiceOperationInfiniteQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<BuildVoiceAgentError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Build
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentVoiceService.buildVoiceAgent.useInfiniteQuery({
     *     path: {
     *         id: id
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends BuildVoiceAgentParameters,
      TQueryFnData = BuildVoiceAgentData,
      TData = OperationInfiniteData<TQueryFnData, BuildVoiceAgentParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>
        | DeepReadonly<BuildVoiceAgentParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          BuildVoiceAgentError,
          TData,
          ServiceOperationInfiniteQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<BuildVoiceAgentData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<BuildVoiceAgentError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Build
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const buildVoiceAgentTotal = qraft.agentVoiceService.buildVoiceAgent.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const buildVoiceAgentByParametersTotal = qraft.agentVoiceService.buildVoiceAgent.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             id: id
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            BuildVoiceAgentSchema,
            BuildVoiceAgentData,
            TInfinite,
            BuildVoiceAgentParameters,
            BuildVoiceAgentError
          >
        | QueryFiltersByQueryKey<
            BuildVoiceAgentSchema,
            BuildVoiceAgentData,
            TInfinite,
            BuildVoiceAgentParameters,
            BuildVoiceAgentError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Build
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const buildVoiceAgentResults = qraft.agentVoiceService.buildVoiceAgent.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 id: id1
     *             }
     *         },
     *         {
     *             path: {
     *                 id: id2
     *             }
     *         }
     *     ]
     * });
     * buildVoiceAgentResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const buildVoiceAgentCombinedResults = qraft.agentVoiceService.buildVoiceAgent.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 id: id1
     *             }
     *         },
     *         {
     *             path: {
     *                 id: id2
     *             }
     *         }
     *     ]
     * });
     * buildVoiceAgentCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          BuildVoiceAgentSchema,
          BuildVoiceAgentParameters,
          BuildVoiceAgentData,
          BuildVoiceAgentError
        >
      >,
      TCombinedResult = Array<UseQueryResult<BuildVoiceAgentData, BuildVoiceAgentError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<BuildVoiceAgentData, BuildVoiceAgentError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Build
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.agentVoiceService.buildVoiceAgent.useSuspenseQuery({
     *     path: {
     *         id: id
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = BuildVoiceAgentData>(
      parameters:
        | ServiceOperationQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>
        | DeepReadonly<BuildVoiceAgentParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          BuildVoiceAgentData,
          BuildVoiceAgentError,
          TData,
          ServiceOperationQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<BuildVoiceAgentError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Build
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentVoiceService.buildVoiceAgent.useSuspenseInfiniteQuery({
     *     path: {
     *         id: id
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends BuildVoiceAgentParameters, TData = BuildVoiceAgentData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>
        | DeepReadonly<BuildVoiceAgentParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          BuildVoiceAgentData,
          BuildVoiceAgentError,
          OperationInfiniteData<TData, BuildVoiceAgentParameters>,
          ServiceOperationInfiniteQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<BuildVoiceAgentData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, BuildVoiceAgentParameters>,
      OperationError<BuildVoiceAgentError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Build
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const buildVoiceAgentData = qraft.agentVoiceService.buildVoiceAgent.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 id: id1
     *             }
     *         },
     *         {
     *             path: {
     *                 id: id2
     *             }
     *         }
     *     ]
     * });
     * buildVoiceAgentResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const buildVoiceAgentCombinedData = qraft.agentVoiceService.buildVoiceAgent.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 id: id1
     *             }
     *         },
     *         {
     *             path: {
     *                 id: id2
     *             }
     *         }
     *     ]
     * });
     * buildVoiceAgentCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          BuildVoiceAgentSchema,
          BuildVoiceAgentParameters,
          BuildVoiceAgentData,
          BuildVoiceAgentError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<BuildVoiceAgentData, BuildVoiceAgentError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<BuildVoiceAgentData, BuildVoiceAgentError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Build */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        BuildVoiceAgentSchema,
        BuildVoiceAgentData,
        BuildVoiceAgentParameters,
        BuildVoiceAgentError
      >
    ): Promise<BuildVoiceAgentData>;
    /** @summary Build */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        BuildVoiceAgentSchema,
        BuildVoiceAgentData,
        BuildVoiceAgentParameters,
        BuildVoiceAgentError
      >
    ): Promise<void>;
    /** @summary Build */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        BuildVoiceAgentSchema,
        BuildVoiceAgentData,
        BuildVoiceAgentParameters,
        BuildVoiceAgentError
      >
    ): Promise<BuildVoiceAgentData>;
    /** @summary Build */
    fetchInfiniteQuery<TPageParam extends BuildVoiceAgentParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        BuildVoiceAgentSchema,
        BuildVoiceAgentData,
        BuildVoiceAgentParameters,
        DeepReadonly<TPageParam>,
        BuildVoiceAgentError
      >
    ): Promise<OperationInfiniteData<BuildVoiceAgentData, BuildVoiceAgentParameters>>;
    /** @summary Build */
    prefetchInfiniteQuery<TPageParam extends BuildVoiceAgentParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        BuildVoiceAgentSchema,
        BuildVoiceAgentData,
        BuildVoiceAgentParameters,
        DeepReadonly<TPageParam>,
        BuildVoiceAgentError
      >
    ): Promise<void>;
    /** @summary Build */
    ensureInfiniteQueryData<TPageParam extends BuildVoiceAgentParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        BuildVoiceAgentSchema,
        BuildVoiceAgentData,
        BuildVoiceAgentParameters,
        DeepReadonly<TPageParam>,
        BuildVoiceAgentError
      >
    ): Promise<OperationInfiniteData<BuildVoiceAgentData, BuildVoiceAgentParameters>>;
    /** @summary Build */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>
        | DeepReadonly<BuildVoiceAgentParameters>
    ): BuildVoiceAgentData | undefined;
    /** @summary Build */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>
        | DeepReadonly<BuildVoiceAgentParameters>
    ): OperationInfiniteData<BuildVoiceAgentData, BuildVoiceAgentParameters> | undefined;
    /** @summary Build */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            BuildVoiceAgentSchema,
            BuildVoiceAgentData,
            TInfinite,
            BuildVoiceAgentParameters,
            BuildVoiceAgentError
          >
        | QueryFiltersByQueryKey<
            BuildVoiceAgentSchema,
            BuildVoiceAgentData,
            TInfinite,
            BuildVoiceAgentParameters,
            BuildVoiceAgentError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>,
            data: NoInfer<OperationInfiniteData<BuildVoiceAgentData, BuildVoiceAgentParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>,
            data: BuildVoiceAgentData | undefined,
          ]
        >;
    /** @summary Build */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>
        | DeepReadonly<BuildVoiceAgentParameters>
    ): QueryState<BuildVoiceAgentData, BuildVoiceAgentError> | undefined;
    /** @summary Build */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<BuildVoiceAgentParameters>
        | ServiceOperationInfiniteQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>
    ):
      | QueryState<OperationInfiniteData<BuildVoiceAgentData, BuildVoiceAgentParameters>, BuildVoiceAgentError>
      | undefined;
    /** @summary Build */
    setQueryData(
      parameters:
        | DeepReadonly<BuildVoiceAgentParameters>
        | ServiceOperationQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>,
      updater: Updater<
        NoInfer<BuildVoiceAgentData> | undefined,
        NoInfer<DeepReadonly<BuildVoiceAgentData>> | undefined
      >,
      options?: SetDataOptions
    ): BuildVoiceAgentData | undefined;
    /** @summary Build */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<BuildVoiceAgentParameters>
        | ServiceOperationInfiniteQueryKey<BuildVoiceAgentSchema, BuildVoiceAgentParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<BuildVoiceAgentData, BuildVoiceAgentParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<BuildVoiceAgentData, BuildVoiceAgentParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<BuildVoiceAgentData, BuildVoiceAgentParameters> | undefined;
    /** @summary Build */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            BuildVoiceAgentSchema,
            BuildVoiceAgentData,
            TInfinite,
            BuildVoiceAgentParameters,
            BuildVoiceAgentError
          >
        | QueryFiltersByQueryKey<
            BuildVoiceAgentSchema,
            BuildVoiceAgentData,
            TInfinite,
            BuildVoiceAgentParameters,
            BuildVoiceAgentError
          >,
      updater: Updater<NoInfer<BuildVoiceAgentData> | undefined, NoInfer<BuildVoiceAgentData> | undefined>,
      options?: SetDataOptions
    ): Array<BuildVoiceAgentData | undefined>;
    /** @summary Build */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        BuildVoiceAgentSchema,
        BuildVoiceAgentData,
        TInfinite,
        BuildVoiceAgentParameters,
        BuildVoiceAgentError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Build */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            BuildVoiceAgentSchema,
            BuildVoiceAgentData,
            TInfinite,
            BuildVoiceAgentParameters,
            BuildVoiceAgentError
          >
        | QueryFiltersByQueryKey<
            BuildVoiceAgentSchema,
            BuildVoiceAgentData,
            TInfinite,
            BuildVoiceAgentParameters,
            BuildVoiceAgentError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Build */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            BuildVoiceAgentSchema,
            BuildVoiceAgentData,
            TInfinite,
            BuildVoiceAgentParameters,
            BuildVoiceAgentError
          >
        | QueryFiltersByQueryKey<
            BuildVoiceAgentSchema,
            BuildVoiceAgentData,
            TInfinite,
            BuildVoiceAgentParameters,
            BuildVoiceAgentError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Build */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            BuildVoiceAgentSchema,
            BuildVoiceAgentData,
            TInfinite,
            BuildVoiceAgentParameters,
            BuildVoiceAgentError
          >
        | QueryFiltersByQueryKey<
            BuildVoiceAgentSchema,
            BuildVoiceAgentData,
            TInfinite,
            BuildVoiceAgentParameters,
            BuildVoiceAgentError
          >
    ): void;
    /** @summary Build */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            BuildVoiceAgentSchema,
            BuildVoiceAgentData,
            TInfinite,
            BuildVoiceAgentParameters,
            BuildVoiceAgentError
          >
        | QueryFiltersByQueryKey<
            BuildVoiceAgentSchema,
            BuildVoiceAgentData,
            TInfinite,
            BuildVoiceAgentParameters,
            BuildVoiceAgentError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Build */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            BuildVoiceAgentSchema,
            BuildVoiceAgentData,
            TInfinite,
            BuildVoiceAgentParameters,
            BuildVoiceAgentError
          >
        | QueryFiltersByQueryKey<
            BuildVoiceAgentSchema,
            BuildVoiceAgentData,
            TInfinite,
            BuildVoiceAgentParameters,
            BuildVoiceAgentError
          >
    ): number;
    schema: BuildVoiceAgentSchema;
    types: {
      parameters: BuildVoiceAgentParameters;
      data: BuildVoiceAgentData;
      error: BuildVoiceAgentError;
    };
  };
  /** @summary Publish */
  publishVoiceAgent: {
    /** @summary Publish */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<PublishVoiceAgentBody, PublishVoiceAgentParameters, TMeta, TSignal>,
      client?: (
        schema: PublishVoiceAgentSchema,
        options: ServiceOperationMutationFnOptions<PublishVoiceAgentBody, PublishVoiceAgentParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<PublishVoiceAgentData, PublishVoiceAgentError>>
    ): Promise<RequestFnResponse<PublishVoiceAgentData, PublishVoiceAgentError>>;
    /** @summary Publish */
    getMutationKey(
      parameters: DeepReadonly<PublishVoiceAgentParameters> | void
    ): ServiceOperationMutationKey<PublishVoiceAgentSchema, PublishVoiceAgentParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Publish
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentVoiceService.publishVoiceAgent.useMutation({
     *     path: {
     *         id: id
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentVoiceService.publishVoiceAgent.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         id: id
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends PublishVoiceAgentBody, TContext = unknown>(
      parameters: DeepReadonly<PublishVoiceAgentParameters>,
      options?: ServiceOperationUseMutationOptions<
        PublishVoiceAgentSchema,
        PublishVoiceAgentData,
        PublishVoiceAgentParameters,
        TVariables,
        OperationError<PublishVoiceAgentError>,
        TContext
      >
    ): UseMutationResult<PublishVoiceAgentData, OperationError<PublishVoiceAgentError>, TVariables | void, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Publish
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentVoiceService.publishVoiceAgent.useMutation({
     *     path: {
     *         id: id
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentVoiceService.publishVoiceAgent.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         id: id
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<PublishVoiceAgentBody, PublishVoiceAgentParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        PublishVoiceAgentSchema,
        PublishVoiceAgentData,
        PublishVoiceAgentParameters,
        TVariables,
        OperationError<PublishVoiceAgentError>,
        TContext
      >
    ): UseMutationResult<PublishVoiceAgentData, OperationError<PublishVoiceAgentError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Publish
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const publishVoiceAgentTotal = qraft.agentVoiceService.publishVoiceAgent.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const publishVoiceAgentTotal = qraft.agentVoiceService.publishVoiceAgent.useIsMutating({
     *     parameters: {
     *         path: {
     *             id: id
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            PublishVoiceAgentBody,
            PublishVoiceAgentData,
            PublishVoiceAgentParameters,
            OperationError<PublishVoiceAgentError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            PublishVoiceAgentSchema,
            PublishVoiceAgentBody,
            PublishVoiceAgentData,
            PublishVoiceAgentParameters,
            OperationError<PublishVoiceAgentError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Publish
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const publishVoiceAgentPendingMutationVariables = qraft.agentVoiceService.publishVoiceAgent.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const publishVoiceAgentMutationData = qraft.agentVoiceService.publishVoiceAgent.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 id: id
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        PublishVoiceAgentData,
        OperationError<PublishVoiceAgentError>,
        MutationVariables<PublishVoiceAgentBody, PublishVoiceAgentParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            PublishVoiceAgentBody,
            PublishVoiceAgentData,
            PublishVoiceAgentParameters,
            OperationError<PublishVoiceAgentError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            PublishVoiceAgentSchema,
            PublishVoiceAgentBody,
            PublishVoiceAgentData,
            PublishVoiceAgentParameters,
            OperationError<PublishVoiceAgentError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          PublishVoiceAgentData,
          OperationError<PublishVoiceAgentError>,
          MutationVariables<PublishVoiceAgentBody, PublishVoiceAgentParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Publish */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            PublishVoiceAgentBody,
            PublishVoiceAgentData,
            PublishVoiceAgentParameters,
            OperationError<PublishVoiceAgentError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            PublishVoiceAgentSchema,
            PublishVoiceAgentBody,
            PublishVoiceAgentData,
            PublishVoiceAgentParameters,
            OperationError<PublishVoiceAgentError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Publish
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentVoiceService.publishVoiceAgent.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             id: id
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentVoiceService.publishVoiceAgent.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              PublishVoiceAgentBody,
              PublishVoiceAgentData,
              PublishVoiceAgentParameters,
              OperationError<PublishVoiceAgentError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              PublishVoiceAgentSchema,
              PublishVoiceAgentBody,
              PublishVoiceAgentData,
              PublishVoiceAgentParameters,
              OperationError<PublishVoiceAgentError>,
              TContext
            >
      ):
        | Mutation<
            PublishVoiceAgentData,
            PublishVoiceAgentError,
            MutationVariables<PublishVoiceAgentBody, PublishVoiceAgentParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              PublishVoiceAgentBody,
              PublishVoiceAgentData,
              PublishVoiceAgentParameters,
              OperationError<PublishVoiceAgentError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              PublishVoiceAgentSchema,
              PublishVoiceAgentBody,
              PublishVoiceAgentData,
              PublishVoiceAgentParameters,
              OperationError<PublishVoiceAgentError>,
              TContext
            >
      ): Array<
        Mutation<
          PublishVoiceAgentData,
          PublishVoiceAgentError,
          MutationVariables<PublishVoiceAgentBody, PublishVoiceAgentParameters>,
          TContext
        >
      >;
    };
    schema: PublishVoiceAgentSchema;
    types: {
      parameters: PublishVoiceAgentParameters;
      data: PublishVoiceAgentData;
      error: PublishVoiceAgentError;
      body: PublishVoiceAgentBody;
    };
  };
  /** @summary Sync With Config */
  syncVoiceAgent: {
    /** @summary Sync With Config */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<SyncVoiceAgentBody, SyncVoiceAgentParameters, TMeta, TSignal>,
      client?: (
        schema: SyncVoiceAgentSchema,
        options: ServiceOperationMutationFnOptions<SyncVoiceAgentBody, SyncVoiceAgentParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<SyncVoiceAgentData, SyncVoiceAgentError>>
    ): Promise<RequestFnResponse<SyncVoiceAgentData, SyncVoiceAgentError>>;
    /** @summary Sync With Config */
    getMutationKey(
      parameters: DeepReadonly<SyncVoiceAgentParameters> | void
    ): ServiceOperationMutationKey<SyncVoiceAgentSchema, SyncVoiceAgentParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Sync With Config
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentVoiceService.syncVoiceAgent.useMutation({
     *     path: {
     *         id: id
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentVoiceService.syncVoiceAgent.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         id: id
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends SyncVoiceAgentBody, TContext = unknown>(
      parameters: DeepReadonly<SyncVoiceAgentParameters>,
      options?: ServiceOperationUseMutationOptions<
        SyncVoiceAgentSchema,
        SyncVoiceAgentData,
        SyncVoiceAgentParameters,
        TVariables,
        OperationError<SyncVoiceAgentError>,
        TContext
      >
    ): UseMutationResult<SyncVoiceAgentData, OperationError<SyncVoiceAgentError>, TVariables | void, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Sync With Config
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentVoiceService.syncVoiceAgent.useMutation({
     *     path: {
     *         id: id
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentVoiceService.syncVoiceAgent.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         id: id
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends MutationVariables<SyncVoiceAgentBody, SyncVoiceAgentParameters>, TContext = unknown>(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        SyncVoiceAgentSchema,
        SyncVoiceAgentData,
        SyncVoiceAgentParameters,
        TVariables,
        OperationError<SyncVoiceAgentError>,
        TContext
      >
    ): UseMutationResult<SyncVoiceAgentData, OperationError<SyncVoiceAgentError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Sync With Config
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const syncVoiceAgentTotal = qraft.agentVoiceService.syncVoiceAgent.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const syncVoiceAgentTotal = qraft.agentVoiceService.syncVoiceAgent.useIsMutating({
     *     parameters: {
     *         path: {
     *             id: id
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            SyncVoiceAgentBody,
            SyncVoiceAgentData,
            SyncVoiceAgentParameters,
            OperationError<SyncVoiceAgentError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SyncVoiceAgentSchema,
            SyncVoiceAgentBody,
            SyncVoiceAgentData,
            SyncVoiceAgentParameters,
            OperationError<SyncVoiceAgentError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Sync With Config
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const syncVoiceAgentPendingMutationVariables = qraft.agentVoiceService.syncVoiceAgent.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const syncVoiceAgentMutationData = qraft.agentVoiceService.syncVoiceAgent.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 id: id
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        SyncVoiceAgentData,
        OperationError<SyncVoiceAgentError>,
        MutationVariables<SyncVoiceAgentBody, SyncVoiceAgentParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            SyncVoiceAgentBody,
            SyncVoiceAgentData,
            SyncVoiceAgentParameters,
            OperationError<SyncVoiceAgentError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SyncVoiceAgentSchema,
            SyncVoiceAgentBody,
            SyncVoiceAgentData,
            SyncVoiceAgentParameters,
            OperationError<SyncVoiceAgentError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          SyncVoiceAgentData,
          OperationError<SyncVoiceAgentError>,
          MutationVariables<SyncVoiceAgentBody, SyncVoiceAgentParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Sync With Config */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            SyncVoiceAgentBody,
            SyncVoiceAgentData,
            SyncVoiceAgentParameters,
            OperationError<SyncVoiceAgentError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SyncVoiceAgentSchema,
            SyncVoiceAgentBody,
            SyncVoiceAgentData,
            SyncVoiceAgentParameters,
            OperationError<SyncVoiceAgentError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Sync With Config
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentVoiceService.syncVoiceAgent.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             id: id
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentVoiceService.syncVoiceAgent.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              SyncVoiceAgentBody,
              SyncVoiceAgentData,
              SyncVoiceAgentParameters,
              OperationError<SyncVoiceAgentError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SyncVoiceAgentSchema,
              SyncVoiceAgentBody,
              SyncVoiceAgentData,
              SyncVoiceAgentParameters,
              OperationError<SyncVoiceAgentError>,
              TContext
            >
      ):
        | Mutation<
            SyncVoiceAgentData,
            SyncVoiceAgentError,
            MutationVariables<SyncVoiceAgentBody, SyncVoiceAgentParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              SyncVoiceAgentBody,
              SyncVoiceAgentData,
              SyncVoiceAgentParameters,
              OperationError<SyncVoiceAgentError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SyncVoiceAgentSchema,
              SyncVoiceAgentBody,
              SyncVoiceAgentData,
              SyncVoiceAgentParameters,
              OperationError<SyncVoiceAgentError>,
              TContext
            >
      ): Array<
        Mutation<
          SyncVoiceAgentData,
          SyncVoiceAgentError,
          MutationVariables<SyncVoiceAgentBody, SyncVoiceAgentParameters>,
          TContext
        >
      >;
    };
    schema: SyncVoiceAgentSchema;
    types: {
      parameters: SyncVoiceAgentParameters;
      data: SyncVoiceAgentData;
      error: SyncVoiceAgentError;
      body: SyncVoiceAgentBody;
    };
  };
  /** @summary Start Call */
  startTestCall: {
    /** @summary Start Call */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<StartTestCallBody, StartTestCallParameters, TMeta, TSignal>,
      client?: (
        schema: StartTestCallSchema,
        options: ServiceOperationMutationFnOptions<StartTestCallBody, StartTestCallParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<StartTestCallData, StartTestCallError>>
    ): Promise<RequestFnResponse<StartTestCallData, StartTestCallError>>;
    /** @summary Start Call */
    getMutationKey(
      parameters: DeepReadonly<StartTestCallParameters> | void
    ): ServiceOperationMutationKey<StartTestCallSchema, StartTestCallParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Start Call
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentVoiceService.startTestCall.useMutation({
     *     path: {
     *         id: id
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentVoiceService.startTestCall.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         id: id
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends StartTestCallBody, TContext = unknown>(
      parameters: DeepReadonly<StartTestCallParameters>,
      options?: ServiceOperationUseMutationOptions<
        StartTestCallSchema,
        StartTestCallData,
        StartTestCallParameters,
        TVariables,
        OperationError<StartTestCallError>,
        TContext
      >
    ): UseMutationResult<StartTestCallData, OperationError<StartTestCallError>, TVariables | void, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Start Call
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentVoiceService.startTestCall.useMutation({
     *     path: {
     *         id: id
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentVoiceService.startTestCall.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         id: id
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends MutationVariables<StartTestCallBody, StartTestCallParameters>, TContext = unknown>(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        StartTestCallSchema,
        StartTestCallData,
        StartTestCallParameters,
        TVariables,
        OperationError<StartTestCallError>,
        TContext
      >
    ): UseMutationResult<StartTestCallData, OperationError<StartTestCallError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Start Call
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const startTestCallTotal = qraft.agentVoiceService.startTestCall.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const startTestCallTotal = qraft.agentVoiceService.startTestCall.useIsMutating({
     *     parameters: {
     *         path: {
     *             id: id
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            StartTestCallBody,
            StartTestCallData,
            StartTestCallParameters,
            OperationError<StartTestCallError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            StartTestCallSchema,
            StartTestCallBody,
            StartTestCallData,
            StartTestCallParameters,
            OperationError<StartTestCallError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Start Call
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const startTestCallPendingMutationVariables = qraft.agentVoiceService.startTestCall.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const startTestCallMutationData = qraft.agentVoiceService.startTestCall.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 id: id
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        StartTestCallData,
        OperationError<StartTestCallError>,
        MutationVariables<StartTestCallBody, StartTestCallParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            StartTestCallBody,
            StartTestCallData,
            StartTestCallParameters,
            OperationError<StartTestCallError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            StartTestCallSchema,
            StartTestCallBody,
            StartTestCallData,
            StartTestCallParameters,
            OperationError<StartTestCallError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          StartTestCallData,
          OperationError<StartTestCallError>,
          MutationVariables<StartTestCallBody, StartTestCallParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Start Call */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            StartTestCallBody,
            StartTestCallData,
            StartTestCallParameters,
            OperationError<StartTestCallError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            StartTestCallSchema,
            StartTestCallBody,
            StartTestCallData,
            StartTestCallParameters,
            OperationError<StartTestCallError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Start Call
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentVoiceService.startTestCall.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             id: id
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentVoiceService.startTestCall.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              StartTestCallBody,
              StartTestCallData,
              StartTestCallParameters,
              OperationError<StartTestCallError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              StartTestCallSchema,
              StartTestCallBody,
              StartTestCallData,
              StartTestCallParameters,
              OperationError<StartTestCallError>,
              TContext
            >
      ):
        | Mutation<
            StartTestCallData,
            StartTestCallError,
            MutationVariables<StartTestCallBody, StartTestCallParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              StartTestCallBody,
              StartTestCallData,
              StartTestCallParameters,
              OperationError<StartTestCallError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              StartTestCallSchema,
              StartTestCallBody,
              StartTestCallData,
              StartTestCallParameters,
              OperationError<StartTestCallError>,
              TContext
            >
      ): Array<
        Mutation<
          StartTestCallData,
          StartTestCallError,
          MutationVariables<StartTestCallBody, StartTestCallParameters>,
          TContext
        >
      >;
    };
    schema: StartTestCallSchema;
    types: {
      parameters: StartTestCallParameters;
      data: StartTestCallData;
      error: StartTestCallError;
      body: StartTestCallBody;
    };
  };
  /** @summary List Voices */
  listVoices: {
    /** @summary List Voices */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<ListVoicesSchema, ListVoicesParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<ListVoicesParameters, TMeta, TSignal> | void),
      client?: (
        schema: ListVoicesSchema,
        options: {
          parameters: ListVoicesParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<ListVoicesData, ListVoicesError>>
    ): Promise<RequestFnResponse<ListVoicesData, ListVoicesError>>;
    /** @summary List Voices */
    getQueryKey(
      parameters: DeepReadonly<ListVoicesParameters> | void
    ): ServiceOperationQueryKey<ListVoicesSchema, ListVoicesParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List Voices
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.agentVoiceService.listVoices.useQuery()
     * ```
     */
    useQuery<TData = ListVoicesData>(
      parameters:
        | ServiceOperationQueryKey<ListVoicesSchema, ListVoicesParameters>
        | (DeepReadonly<ListVoicesParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          ListVoicesData,
          ListVoicesError,
          TData,
          ServiceOperationQueryKey<ListVoicesSchema, ListVoicesParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<ListVoicesError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List Voices
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.agentVoiceService.listVoices.useQuery()
     * ```
     */
    useQuery<TData = ListVoicesData>(
      parameters:
        | ServiceOperationQueryKey<ListVoicesSchema, ListVoicesParameters>
        | (DeepReadonly<ListVoicesParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          ListVoicesData,
          ListVoicesError,
          TData,
          ServiceOperationQueryKey<ListVoicesSchema, ListVoicesParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<ListVoicesError>>;
    /** @summary List Voices */
    getInfiniteQueryKey(
      parameters: DeepReadonly<ListVoicesParameters> | void
    ): ServiceOperationInfiniteQueryKey<ListVoicesSchema, ListVoicesParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List Voices
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentVoiceService.listVoices.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListVoicesParameters,
      TQueryFnData = ListVoicesData,
      TData = OperationInfiniteData<TQueryFnData, ListVoicesParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListVoicesSchema, ListVoicesParameters>
        | (DeepReadonly<ListVoicesParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListVoicesError,
          TData,
          ServiceOperationInfiniteQueryKey<ListVoicesSchema, ListVoicesParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<ListVoicesError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List Voices
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentVoiceService.listVoices.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListVoicesParameters,
      TQueryFnData = ListVoicesData,
      TData = OperationInfiniteData<TQueryFnData, ListVoicesParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListVoicesSchema, ListVoicesParameters>
        | (DeepReadonly<ListVoicesParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListVoicesError,
          TData,
          ServiceOperationInfiniteQueryKey<ListVoicesSchema, ListVoicesParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ListVoicesData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<ListVoicesError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary List Voices
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const listVoicesTotal = qraft.agentVoiceService.listVoices.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<ListVoicesSchema, ListVoicesData, TInfinite, ListVoicesParameters, ListVoicesError>
        | QueryFiltersByQueryKey<ListVoicesSchema, ListVoicesData, TInfinite, ListVoicesParameters, ListVoicesError>
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary List Voices
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const listVoicesResults = qraft.agentVoiceService.listVoices.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listVoicesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const listVoicesCombinedResults = qraft.agentVoiceService.listVoices.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listVoicesCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<ListVoicesSchema, ListVoicesParameters, ListVoicesData, ListVoicesError>
      >,
      TCombinedResult = Array<UseQueryResult<ListVoicesData, ListVoicesError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<ListVoicesData, ListVoicesError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary List Voices
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.agentVoiceService.listVoices.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = ListVoicesData>(
      parameters:
        | ServiceOperationQueryKey<ListVoicesSchema, ListVoicesParameters>
        | (DeepReadonly<ListVoicesParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          ListVoicesData,
          ListVoicesError,
          TData,
          ServiceOperationQueryKey<ListVoicesSchema, ListVoicesParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<ListVoicesError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary List Voices
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentVoiceService.listVoices.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends ListVoicesParameters, TData = ListVoicesData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListVoicesSchema, ListVoicesParameters>
        | (DeepReadonly<ListVoicesParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          ListVoicesData,
          ListVoicesError,
          OperationInfiniteData<TData, ListVoicesParameters>,
          ServiceOperationInfiniteQueryKey<ListVoicesSchema, ListVoicesParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ListVoicesData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, ListVoicesParameters>,
      OperationError<ListVoicesError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary List Voices
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const listVoicesData = qraft.agentVoiceService.listVoices.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listVoicesResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const listVoicesCombinedData = qraft.agentVoiceService.listVoices.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listVoicesCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<ListVoicesSchema, ListVoicesParameters, ListVoicesData, ListVoicesError>
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<ListVoicesData, ListVoicesError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<ListVoicesData, ListVoicesError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary List Voices */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListVoicesSchema,
        ListVoicesData,
        ListVoicesParameters,
        ListVoicesError
      > | void
    ): Promise<ListVoicesData>;
    /** @summary List Voices */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListVoicesSchema,
        ListVoicesData,
        ListVoicesParameters,
        ListVoicesError
      > | void
    ): Promise<void>;
    /** @summary List Voices */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        ListVoicesSchema,
        ListVoicesData,
        ListVoicesParameters,
        ListVoicesError
      > | void
    ): Promise<ListVoicesData>;
    /** @summary List Voices */
    fetchInfiniteQuery<TPageParam extends ListVoicesParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListVoicesSchema,
        ListVoicesData,
        ListVoicesParameters,
        DeepReadonly<TPageParam>,
        ListVoicesError
      > | void
    ): Promise<OperationInfiniteData<ListVoicesData, ListVoicesParameters>>;
    /** @summary List Voices */
    prefetchInfiniteQuery<TPageParam extends ListVoicesParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListVoicesSchema,
        ListVoicesData,
        ListVoicesParameters,
        DeepReadonly<TPageParam>,
        ListVoicesError
      > | void
    ): Promise<void>;
    /** @summary List Voices */
    ensureInfiniteQueryData<TPageParam extends ListVoicesParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        ListVoicesSchema,
        ListVoicesData,
        ListVoicesParameters,
        DeepReadonly<TPageParam>,
        ListVoicesError
      > | void
    ): Promise<OperationInfiniteData<ListVoicesData, ListVoicesParameters>>;
    /** @summary List Voices */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<ListVoicesSchema, ListVoicesParameters>
        | (DeepReadonly<ListVoicesParameters> | void)
    ): ListVoicesData | undefined;
    /** @summary List Voices */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListVoicesSchema, ListVoicesParameters>
        | (DeepReadonly<ListVoicesParameters> | void)
    ): OperationInfiniteData<ListVoicesData, ListVoicesParameters> | undefined;
    /** @summary List Voices */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<ListVoicesSchema, ListVoicesData, TInfinite, ListVoicesParameters, ListVoicesError>
        | QueryFiltersByQueryKey<ListVoicesSchema, ListVoicesData, TInfinite, ListVoicesParameters, ListVoicesError>
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<ListVoicesSchema, ListVoicesParameters>,
            data: NoInfer<OperationInfiniteData<ListVoicesData, ListVoicesParameters>> | undefined,
          ]
        >
      : Array<
          [queryKey: ServiceOperationQueryKey<ListVoicesSchema, ListVoicesParameters>, data: ListVoicesData | undefined]
        >;
    /** @summary List Voices */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<ListVoicesSchema, ListVoicesParameters>
        | (DeepReadonly<ListVoicesParameters> | void)
    ): QueryState<ListVoicesData, ListVoicesError> | undefined;
    /** @summary List Voices */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<ListVoicesParameters>
        | ServiceOperationInfiniteQueryKey<ListVoicesSchema, ListVoicesParameters>
        | void
    ): QueryState<OperationInfiniteData<ListVoicesData, ListVoicesParameters>, ListVoicesError> | undefined;
    /** @summary List Voices */
    setQueryData(
      parameters:
        | (DeepReadonly<ListVoicesParameters> | undefined)
        | ServiceOperationQueryKey<ListVoicesSchema, ListVoicesParameters>,
      updater: Updater<NoInfer<ListVoicesData> | undefined, NoInfer<DeepReadonly<ListVoicesData>> | undefined>,
      options?: SetDataOptions
    ): ListVoicesData | undefined;
    /** @summary List Voices */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<ListVoicesParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<ListVoicesSchema, ListVoicesParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<ListVoicesData, ListVoicesParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<ListVoicesData, ListVoicesParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<ListVoicesData, ListVoicesParameters> | undefined;
    /** @summary List Voices */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<ListVoicesSchema, ListVoicesData, TInfinite, ListVoicesParameters, ListVoicesError>
        | QueryFiltersByQueryKey<ListVoicesSchema, ListVoicesData, TInfinite, ListVoicesParameters, ListVoicesError>,
      updater: Updater<NoInfer<ListVoicesData> | undefined, NoInfer<ListVoicesData> | undefined>,
      options?: SetDataOptions
    ): Array<ListVoicesData | undefined>;
    /** @summary List Voices */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        ListVoicesSchema,
        ListVoicesData,
        TInfinite,
        ListVoicesParameters,
        ListVoicesError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary List Voices */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<ListVoicesSchema, ListVoicesData, TInfinite, ListVoicesParameters, ListVoicesError>
        | QueryFiltersByQueryKey<ListVoicesSchema, ListVoicesData, TInfinite, ListVoicesParameters, ListVoicesError>,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary List Voices */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<ListVoicesSchema, ListVoicesData, TInfinite, ListVoicesParameters, ListVoicesError>
        | QueryFiltersByQueryKey<ListVoicesSchema, ListVoicesData, TInfinite, ListVoicesParameters, ListVoicesError>,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary List Voices */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<ListVoicesSchema, ListVoicesData, TInfinite, ListVoicesParameters, ListVoicesError>
        | QueryFiltersByQueryKey<ListVoicesSchema, ListVoicesData, TInfinite, ListVoicesParameters, ListVoicesError>
    ): void;
    /** @summary List Voices */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<ListVoicesSchema, ListVoicesData, TInfinite, ListVoicesParameters, ListVoicesError>
        | QueryFiltersByQueryKey<ListVoicesSchema, ListVoicesData, TInfinite, ListVoicesParameters, ListVoicesError>,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary List Voices */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<ListVoicesSchema, ListVoicesData, TInfinite, ListVoicesParameters, ListVoicesError>
        | QueryFiltersByQueryKey<ListVoicesSchema, ListVoicesData, TInfinite, ListVoicesParameters, ListVoicesError>
    ): number;
    schema: ListVoicesSchema;
    types: {
      parameters: ListVoicesParameters;
      data: ListVoicesData;
      error: ListVoicesError;
    };
  };
  /** @summary Run Sync */
  runVoiceAgentSync: {
    /** @summary Run Sync */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<RunVoiceAgentSyncBody, RunVoiceAgentSyncParameters, TMeta, TSignal>,
      client?: (
        schema: RunVoiceAgentSyncSchema,
        options: ServiceOperationMutationFnOptions<RunVoiceAgentSyncBody, RunVoiceAgentSyncParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<RunVoiceAgentSyncData, RunVoiceAgentSyncError>>
    ): Promise<RequestFnResponse<RunVoiceAgentSyncData, RunVoiceAgentSyncError>>;
    /** @summary Run Sync */
    getMutationKey(
      parameters: DeepReadonly<RunVoiceAgentSyncParameters> | void
    ): ServiceOperationMutationKey<RunVoiceAgentSyncSchema, RunVoiceAgentSyncParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Run Sync
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentVoiceService.runVoiceAgentSync.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentVoiceService.runVoiceAgentSync.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends RunVoiceAgentSyncBody, TContext = unknown>(
      parameters: DeepReadonly<RunVoiceAgentSyncParameters>,
      options?: ServiceOperationUseMutationOptions<
        RunVoiceAgentSyncSchema,
        RunVoiceAgentSyncData,
        RunVoiceAgentSyncParameters,
        TVariables,
        OperationError<RunVoiceAgentSyncError>,
        TContext
      >
    ): UseMutationResult<RunVoiceAgentSyncData, OperationError<RunVoiceAgentSyncError>, TVariables | void, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Run Sync
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentVoiceService.runVoiceAgentSync.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentVoiceService.runVoiceAgentSync.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<RunVoiceAgentSyncBody, RunVoiceAgentSyncParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        RunVoiceAgentSyncSchema,
        RunVoiceAgentSyncData,
        RunVoiceAgentSyncParameters,
        TVariables,
        OperationError<RunVoiceAgentSyncError>,
        TContext
      >
    ): UseMutationResult<RunVoiceAgentSyncData, OperationError<RunVoiceAgentSyncError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Run Sync
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const runVoiceAgentSyncTotal = qraft.agentVoiceService.runVoiceAgentSync.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const runVoiceAgentSyncTotal = qraft.agentVoiceService.runVoiceAgentSync.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            RunVoiceAgentSyncBody,
            RunVoiceAgentSyncData,
            RunVoiceAgentSyncParameters,
            OperationError<RunVoiceAgentSyncError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RunVoiceAgentSyncSchema,
            RunVoiceAgentSyncBody,
            RunVoiceAgentSyncData,
            RunVoiceAgentSyncParameters,
            OperationError<RunVoiceAgentSyncError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Run Sync
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const runVoiceAgentSyncPendingMutationVariables = qraft.agentVoiceService.runVoiceAgentSync.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const runVoiceAgentSyncMutationData = qraft.agentVoiceService.runVoiceAgentSync.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        RunVoiceAgentSyncData,
        OperationError<RunVoiceAgentSyncError>,
        MutationVariables<RunVoiceAgentSyncBody, RunVoiceAgentSyncParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            RunVoiceAgentSyncBody,
            RunVoiceAgentSyncData,
            RunVoiceAgentSyncParameters,
            OperationError<RunVoiceAgentSyncError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RunVoiceAgentSyncSchema,
            RunVoiceAgentSyncBody,
            RunVoiceAgentSyncData,
            RunVoiceAgentSyncParameters,
            OperationError<RunVoiceAgentSyncError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          RunVoiceAgentSyncData,
          OperationError<RunVoiceAgentSyncError>,
          MutationVariables<RunVoiceAgentSyncBody, RunVoiceAgentSyncParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Run Sync */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            RunVoiceAgentSyncBody,
            RunVoiceAgentSyncData,
            RunVoiceAgentSyncParameters,
            OperationError<RunVoiceAgentSyncError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RunVoiceAgentSyncSchema,
            RunVoiceAgentSyncBody,
            RunVoiceAgentSyncData,
            RunVoiceAgentSyncParameters,
            OperationError<RunVoiceAgentSyncError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Run Sync
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentVoiceService.runVoiceAgentSync.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentVoiceService.runVoiceAgentSync.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              RunVoiceAgentSyncBody,
              RunVoiceAgentSyncData,
              RunVoiceAgentSyncParameters,
              OperationError<RunVoiceAgentSyncError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              RunVoiceAgentSyncSchema,
              RunVoiceAgentSyncBody,
              RunVoiceAgentSyncData,
              RunVoiceAgentSyncParameters,
              OperationError<RunVoiceAgentSyncError>,
              TContext
            >
      ):
        | Mutation<
            RunVoiceAgentSyncData,
            RunVoiceAgentSyncError,
            MutationVariables<RunVoiceAgentSyncBody, RunVoiceAgentSyncParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              RunVoiceAgentSyncBody,
              RunVoiceAgentSyncData,
              RunVoiceAgentSyncParameters,
              OperationError<RunVoiceAgentSyncError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              RunVoiceAgentSyncSchema,
              RunVoiceAgentSyncBody,
              RunVoiceAgentSyncData,
              RunVoiceAgentSyncParameters,
              OperationError<RunVoiceAgentSyncError>,
              TContext
            >
      ): Array<
        Mutation<
          RunVoiceAgentSyncData,
          RunVoiceAgentSyncError,
          MutationVariables<RunVoiceAgentSyncBody, RunVoiceAgentSyncParameters>,
          TContext
        >
      >;
    };
    schema: RunVoiceAgentSyncSchema;
    types: {
      parameters: RunVoiceAgentSyncParameters;
      data: RunVoiceAgentSyncData;
      error: RunVoiceAgentSyncError;
      body: RunVoiceAgentSyncBody;
    };
  };
}
/** @summary Get Default */
export const getDefaultVoiceAgent = {
  schema: {
    method: 'get',
    url: '/agent/voice/default',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetDefaultVoiceAgentSchema;
  [QraftServiceOperationsToken]: AgentVoiceService['getDefaultVoiceAgent'];
};
/** @summary Create Default */
export const createDefaultVoiceAgent = {
  schema: {
    method: 'post',
    url: '/agent/voice/default',
    security: ['HTTPBearer'],
  },
} as {
  schema: CreateDefaultVoiceAgentSchema;
  [QraftServiceOperationsToken]: AgentVoiceService['createDefaultVoiceAgent'];
};
/** @summary List Voice Agents */
export const listVoiceAgents = {
  schema: {
    method: 'get',
    url: '/agent/voice/',
    security: ['HTTPBearer'],
  },
} as {
  schema: ListVoiceAgentsSchema;
  [QraftServiceOperationsToken]: AgentVoiceService['listVoiceAgents'];
};
/** @summary Create */
export const createVoiceAgent = {
  schema: {
    method: 'post',
    url: '/agent/voice/',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: CreateVoiceAgentSchema;
  [QraftServiceOperationsToken]: AgentVoiceService['createVoiceAgent'];
};
/** @summary Update */
export const updateVoiceAgent = {
  schema: {
    method: 'patch',
    url: '/agent/voice/{id}',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: UpdateVoiceAgentSchema;
  [QraftServiceOperationsToken]: AgentVoiceService['updateVoiceAgent'];
};
/** @summary Build */
export const buildVoiceAgent = {
  schema: {
    method: 'get',
    url: '/agent/voice/{id}/build',
    security: ['HTTPBearer'],
  },
} as {
  schema: BuildVoiceAgentSchema;
  [QraftServiceOperationsToken]: AgentVoiceService['buildVoiceAgent'];
};
/** @summary Publish */
export const publishVoiceAgent = {
  schema: {
    method: 'post',
    url: '/agent/voice/{id}/publish',
    security: ['HTTPBearer'],
  },
} as {
  schema: PublishVoiceAgentSchema;
  [QraftServiceOperationsToken]: AgentVoiceService['publishVoiceAgent'];
};
/** @summary Sync With Config */
export const syncVoiceAgent = {
  schema: {
    method: 'post',
    url: '/agent/voice/{id}/sync-with-config',
    security: ['HTTPBearer'],
  },
} as {
  schema: SyncVoiceAgentSchema;
  [QraftServiceOperationsToken]: AgentVoiceService['syncVoiceAgent'];
};
/** @summary Start Call */
export const startTestCall = {
  schema: {
    method: 'post',
    url: '/agent/voice/{id}/start-call',
    security: ['HTTPBearer'],
  },
} as {
  schema: StartTestCallSchema;
  [QraftServiceOperationsToken]: AgentVoiceService['startTestCall'];
};
/** @summary List Voices */
export const listVoices = {
  schema: {
    method: 'get',
    url: '/agent/voice/voices',
    security: ['HTTPBearer'],
  },
} as {
  schema: ListVoicesSchema;
  [QraftServiceOperationsToken]: AgentVoiceService['listVoices'];
};
/** @summary Run Sync */
export const runVoiceAgentSync = {
  schema: {
    method: 'post',
    url: '/agent/voice/run-sync',
    security: ['HTTPBearer'],
  },
} as {
  schema: RunVoiceAgentSyncSchema;
  [QraftServiceOperationsToken]: AgentVoiceService['runVoiceAgentSync'];
};
export const agentVoiceService = {
  getDefaultVoiceAgent,
  createDefaultVoiceAgent,
  listVoiceAgents,
  createVoiceAgent,
  updateVoiceAgent,
  buildVoiceAgent,
  publishVoiceAgent,
  syncVoiceAgent,
  startTestCall,
  listVoices,
  runVoiceAgentSync,
} as const;
type GetDefaultVoiceAgentSchema = {
  method: 'get';
  url: '/agent/voice/default';
  security: ['HTTPBearer'];
};
type GetDefaultVoiceAgentParameters = undefined;
type GetDefaultVoiceAgentData = paths['/agent/voice/default']['get']['responses']['200']['content']['application/json'];
type GetDefaultVoiceAgentError = unknown;
type CreateDefaultVoiceAgentSchema = {
  method: 'post';
  url: '/agent/voice/default';
  security: ['HTTPBearer'];
};
type CreateDefaultVoiceAgentParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateDefaultVoiceAgentData =
  paths['/agent/voice/default']['post']['responses']['200']['content']['application/json'];
type CreateDefaultVoiceAgentError = unknown;
type CreateDefaultVoiceAgentBody = undefined;
type ListVoiceAgentsSchema = {
  method: 'get';
  url: '/agent/voice/';
  security: ['HTTPBearer'];
};
type ListVoiceAgentsParameters = undefined;
type ListVoiceAgentsData = paths['/agent/voice/']['get']['responses']['200']['content']['application/json'];
type ListVoiceAgentsError = unknown;
type CreateVoiceAgentSchema = {
  method: 'post';
  url: '/agent/voice/';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type CreateVoiceAgentParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateVoiceAgentData = paths['/agent/voice/']['post']['responses']['200']['content']['application/json'];
type CreateVoiceAgentError = paths['/agent/voice/']['post']['responses']['422']['content']['application/json'];
type CreateVoiceAgentBody = paths['/agent/voice/']['post']['requestBody']['content']['application/json'];
type UpdateVoiceAgentSchema = {
  method: 'patch';
  url: '/agent/voice/{id}';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type UpdateVoiceAgentParameters = paths['/agent/voice/{id}']['patch']['parameters'];
type UpdateVoiceAgentData = paths['/agent/voice/{id}']['patch']['responses']['200']['content']['application/json'];
type UpdateVoiceAgentError = paths['/agent/voice/{id}']['patch']['responses']['422']['content']['application/json'];
type UpdateVoiceAgentBody = paths['/agent/voice/{id}']['patch']['requestBody']['content']['application/json'];
type BuildVoiceAgentSchema = {
  method: 'get';
  url: '/agent/voice/{id}/build';
  security: ['HTTPBearer'];
};
type BuildVoiceAgentParameters = paths['/agent/voice/{id}/build']['get']['parameters'];
type BuildVoiceAgentData = paths['/agent/voice/{id}/build']['get']['responses']['200']['content']['application/json'];
type BuildVoiceAgentError = paths['/agent/voice/{id}/build']['get']['responses']['422']['content']['application/json'];
type PublishVoiceAgentSchema = {
  method: 'post';
  url: '/agent/voice/{id}/publish';
  security: ['HTTPBearer'];
};
type PublishVoiceAgentParameters = paths['/agent/voice/{id}/publish']['post']['parameters'];
type PublishVoiceAgentData =
  paths['/agent/voice/{id}/publish']['post']['responses']['200']['content']['application/json'];
type PublishVoiceAgentError =
  paths['/agent/voice/{id}/publish']['post']['responses']['422']['content']['application/json'];
type PublishVoiceAgentBody = undefined;
type SyncVoiceAgentSchema = {
  method: 'post';
  url: '/agent/voice/{id}/sync-with-config';
  security: ['HTTPBearer'];
};
type SyncVoiceAgentParameters = paths['/agent/voice/{id}/sync-with-config']['post']['parameters'];
type SyncVoiceAgentData =
  paths['/agent/voice/{id}/sync-with-config']['post']['responses']['200']['content']['application/json'];
type SyncVoiceAgentError =
  paths['/agent/voice/{id}/sync-with-config']['post']['responses']['422']['content']['application/json'];
type SyncVoiceAgentBody = undefined;
type StartTestCallSchema = {
  method: 'post';
  url: '/agent/voice/{id}/start-call';
  security: ['HTTPBearer'];
};
type StartTestCallParameters = paths['/agent/voice/{id}/start-call']['post']['parameters'];
type StartTestCallData =
  paths['/agent/voice/{id}/start-call']['post']['responses']['200']['content']['application/json'];
type StartTestCallError =
  paths['/agent/voice/{id}/start-call']['post']['responses']['422']['content']['application/json'];
type StartTestCallBody = undefined;
type ListVoicesSchema = {
  method: 'get';
  url: '/agent/voice/voices';
  security: ['HTTPBearer'];
};
type ListVoicesParameters = undefined;
type ListVoicesData = paths['/agent/voice/voices']['get']['responses']['200']['content']['application/json'];
type ListVoicesError = unknown;
type RunVoiceAgentSyncSchema = {
  method: 'post';
  url: '/agent/voice/run-sync';
  security: ['HTTPBearer'];
};
type RunVoiceAgentSyncParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type RunVoiceAgentSyncData = paths['/agent/voice/run-sync']['post']['responses']['200']['content']['application/json'];
type RunVoiceAgentSyncError = unknown;
type RunVoiceAgentSyncBody = undefined;
